const conditionalDefaults = {
  id: {
    order: 0,
    value: () => undefined,
  },
  answerLaterTrigger: {
    order: 0,
    value: () => 'none',
  },
  triggerStyle: {
    order: 0,
    value: () => 'floatingButton',
  },
  triggerPosition: {
    order: 0,
    value: () => 'centerRight',
  },
  buttonIcon: {
    order: 0,
    value: () => 'comments',
  },
  includedUrls: {
    order: 0,
    value: () => [],
  },
  excludedUrls: {
    order: 0,
    value: () => [],
  },
  excludedIPs: {
    order: 0,
    value: () => [],
  },
  groupSurveyIds: {
    order: 0,
    value: () => [],
  },
  popupWidth: {
    order: 0,
    value: () => 520,
  },
  popupHeight: {
    order: 0,
    value: () => 480,
  },
  portion: {
    order: 0,
    value: () => 100,
  },
  deviceTypes: {
    order: 0,
    value: () => ['MOBILE', 'TABLET', 'DESKTOP'],
  },
  elementSelector: {
    order: 0,
    value: () => '',
  },
  container: {
    order: 0,
    value: () => 'popupWindow',
  },
  containerType: {
    order: 0,
    value: () => 'modal',
  },
  trigger: {
    order: 1,
    value: ({ container }) => (container === 'popupWindow' ? 'invisibleLayer' : 'none'),
  },
  delay: {
    order: 2,
    value: ({ trigger }) => (trigger === 'button' ? 0 : 120),
  },
  idle: {
    order: 2,
    value: ({ trigger }) => (trigger === 'button' ? 0 : 600),
  },
  frequency: {
    order: 2,
    value: ({ trigger }) => (trigger === 'button' ? 0 : 7776e3),
  },
  declineFrequency: {
    order: 2,
    value: ({ trigger }) => (trigger === 'button' ? 0 : 14 * 24 * 60 * 60 * 1000),
  },
  theme: {
    order: 0,
    value: () => 'default',
  },
};

export const getValues = (values = {}) => {
  const defaultKeys = Object.keys(conditionalDefaults).sort((keyA, keyB) => conditionalDefaults[keyA].order - conditionalDefaults[keyB].order);

  const newConditionalDefaults = defaultKeys
    .reduce((acc, key) => {
      acc[key] = ![null, '', undefined].includes(values[key]) ? () => values[key] : conditionalDefaults[key].value;
      return acc;
    }, {});

  return defaultKeys.reduce((acc, key) => {
    acc[key] = newConditionalDefaults[key](acc);
    return acc;
  }, {});
};

export const getValue = (key, values = {}) => {
  const newValues = getValues(values);
  return newValues[key];
};
